let _successToast = () => {}
let _primaryToast = () => {}
let _errorToast = () => {}
let _makeToast = () => {}

/* eslint-env browser */

if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  const { toast } = require('bulma-toast')

  _makeToast = ({ message, type }) => {
    toast({
      message,
      type,
      dismissible: true,
      position: 'top-right',
      animate: { in: 'fadeIn', out: 'fadeOut' },
    })
  }

  _successToast = ({ message }) => {
    _makeToast({ message, type: 'is-success' })
  }

  _primaryToast = ({ message }) => {
    _makeToast({ message, type: 'is-primary' })
  }

  _errorToast = ({ message }) => {
    _makeToast({ message, type: 'is-danger' })
  }
}

const makeToast = _makeToast
export default makeToast

export const successToast = _successToast

export const primaryToast = _primaryToast

export const errorToast = _errorToast
